import React, { Component, useState, useEffect, useContext } from "react";
import BannerImage from "../assets/hero-image.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";
import { MyContext } from "../MyContext";
import { IconContext } from "react-icons";
import { Link } from "react-router-dom";

const Home = () => {
  const { books } = useContext(MyContext);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="home-container" id="#home">
      <div className="home-banner-container">
        <div className="home-text-section">
          <h1 className="primary-heading">
          Nowatorskie ebooki i książki o języku angielskim
          </h1>
          <p className="primary-text">
          Nauka na każdym poziomie zaawansowania
          </p>
          <Link to="/store"><button className="secondary-button">
            Zamów &nbsp; {">"}
          </button></Link>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  )
}

export default Home